import React, { useState } from 'react';
import { Modal, Button, Input, Col, Row, Select, Form } from 'antd';
import localStorage from '../../localStorage';
import config from '../../config';
import { capitalize } from 'lodash';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';



const Debug = () => {


  const [form] = Form.useForm();

  const [visible, setVisible] = useState(false);
  const current = typeof window !== 'undefined' && localStorage.loadState('api');
  const [initialValue, setInitialValue] = useState(current);
  const api = [];
  const general = useGeneralStore();

  for (const key in config.api) {
    if (config.api.hasOwnProperty(key)) {
      const element = config.api[key];
      api.push({
        name: key,
        value: element,
      });
    }
  }

  function onFinish(values) {
    if (typeof window !== 'undefined') {
      localStorage.saveState(values.url, 'api');
    }
    general.NotifSuccess('آدرس با موفقیت تغییر یافت');
    setVisible(false);
  }

  function onFinishFailed(errorInfo) {
    form.scrollToField(errorInfo.errorFields[0].name, {
      scroll: {
        offsetTop: 65,
      },
    });
  }

  return (
    <div>
      <a id="debug-button" onClick={() => setVisible(true)}> دیباگ</a>
      <Modal
        title=""
        footer={null}
        open={visible}
        onCancel={() => setVisible(false)}>
        <Form onFinish={onFinish} form={form} onFinishFailed={onFinishFailed} initialValues={initialValue} style={{marginTop:"50px"}}>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Select 
                  placeholder="پیش‌فرض"
                  size="large"
                  onChange={(event) => {
                    setInitialValue(event)
                    form.setFieldsValue({ url: event })
                  }}>
                  {api.map((item) => <Select.Option value={item.value} key={item.value}>{capitalize(item.name)}</Select.Option>)}
                </Select>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="url"
                rules={[{ required: true, message: "سرویس وارد شده معتبر نیست" }]}
              >
                <Input
                  allowClear
                  size="large"
                  style={{ direction: 'ltr' }}
                  placeholder="آدرس سرویس" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item>
                <Button
                  size="large"
                  type="primary" htmlType="submit" block>ثبت</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div >
  );
}

export default Debug
